import React, { useState } from 'react';
import SpeedFuelConsumption from './SpeedFuelConsumption';
import SOGDraftOverTime from './SOGDraftOverTime';
import FuelConsumptionOverTime from './FuelConsumptionOverTime';
import SOGvsCargoLoad from './SOGvsCargoLoad';
import { Gauge } from 'lucide-react';

const VoyagePerformance = ({ voyageId, selectedEngine }) => {
  const [activeGraph, setActiveGraph] = useState('speedFuel');

  const graphComponents = {
    speedFuel: <SpeedFuelConsumption voyageId={voyageId} selectedEngine={selectedEngine} />,
    sogDraft: <SOGDraftOverTime voyageId={voyageId} selectedEngine={selectedEngine} />,
    fuelTime: <FuelConsumptionOverTime voyageId={voyageId} selectedEngine={selectedEngine} />,
    sogLoad: <SOGvsCargoLoad voyageId={voyageId} selectedEngine={selectedEngine} />
  };

  const getButtonStyle = (graphKey) => {
    const isActive = activeGraph === graphKey;
    const baseColor = '#27ade3';

    return isActive
      ? {
        backgroundColor: `${baseColor}20`, // 20% opacity
        color: baseColor,
        borderColor: baseColor
      }
      : {};
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div
            className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
            <Gauge className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900">
            Voyage Performance & Fuel Efficiency
          </h2>
        </div>

        <div className="flex gap-2 flex-wrap">
          <button
            onClick={() => setActiveGraph('speedFuel')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${activeGraph === 'speedFuel'
              ? 'font-medium border'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            style={getButtonStyle('speedFuel')}
          >
            Fuel vs. Speed
          </button>
          <button
            onClick={() => setActiveGraph('sogDraft')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${activeGraph === 'sogDraft'
              ? 'font-medium border'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            style={getButtonStyle('sogDraft')}
          >
            SOG & Draft
          </button>
          <button
            onClick={() => setActiveGraph('fuelTime')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${activeGraph === 'fuelTime'
              ? 'font-medium border'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            style={getButtonStyle('fuelTime')}
          >
            Fuel Over Time
          </button>
          <button
            onClick={() => setActiveGraph('sogLoad')}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${activeGraph === 'sogLoad'
              ? 'font-medium border'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            style={getButtonStyle('sogLoad')}
          >
            SOG vs Load
          </button>
        </div>
      </div>

      {/* Chart Container */}
      <div className="p-4 bg-gray-50">
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          {graphComponents[activeGraph]}
        </div>
      </div>
    </div>
  );
};

export default VoyagePerformance;